import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import api from "../services/api";

const TaxStatusPage = () => {
    const { id } = useParams(); // Get business ID from the URL
    const [taxStatus, setTaxStatus] = useState(null); // Store fetched tax status
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchTaxStatus = async () => {
            try {
                const { data } = await api.get(`/tax-status-fetch/${id}`); // Fetch tax status
                setTaxStatus(data); // Set the fetched data
            } catch (error) {
                console.error("Error fetching tax status:", error);
                setError("Failed to fetch tax status. Please try again later.");
            } finally {
                setLoading(false);
            }
        };

        fetchTaxStatus();
    }, [id]);

    if (loading) return <p>Loading tax status...</p>;
    if (error) return <p style={{ color: "red" }}>{error}</p>;
    if (!taxStatus) return <p>No tax status found.</p>;

    // Extract missing fields
    const { hasMissingFederalFields, hasMissingCityFields, hasMissingStateFields } = taxStatus.missingFields;

    return (
        <div style={{ padding: "20px" }}>
            <h2>Tax Status</h2>
            <p><strong>Business ID:</strong> {id}</p>

            {taxStatus.noIssues ? (
                <p style={{ color: "green", fontWeight: "bold" }}>✅ All tax information is up to date!</p>
            ) : (
                <div style={{ color: "red", fontWeight: "bold" }}>
                    <p>⚠️ There are missing tax fields. Please address them:</p>
                    <ul>
                        {hasMissingFederalFields && <li>⚠️ Missing **Federal Tax Information**</li>}
                        {hasMissingStateFields && <li>⚠️ Missing **State Tax Information**</li>}
                        {hasMissingCityFields && <li>⚠️ Missing **City Tax Information**</li>}
                    </ul>
                </div>
            )}

            <h3>Debugging Details</h3>
            <pre style={{ background: "#f4f4f4", padding: "10px", borderRadius: "5px" }}>
                {JSON.stringify(taxStatus, null, 2)}
            </pre>
        </div>
    );
};

export default TaxStatusPage;


